import React, { useEffect, useMemo, useRef, useState } from "react";
import { Radio, Icon, Tag } from "antd";
import ReactGA from "react-ga4";

import { isObject, formatNumber, checkEmptyArray } from "../../services/utils";
import { handleSearchControl } from "../../routes/Search/HOCs";
import SearchControls from "../../components/SearchControls";
import { getAdvancedSearchConfig } from "../../dataConfig";
import { checkEmptyObject, getRecentSearchQuery, getUrlParams, scrollToTop, stringifyURI } from "../../services";
import { filterGroupsByCondition, getHiddenFieldNames, removeHiddenFields } from "../../utils/searchFilterConditions";
import styles from "./styles/FilterSection.scss";
import IndexSelect from "../../components/FormControls/IndexSelect";
import SearchSubmitButton from "../../components/SearchSubmitButton";
import { getIconUrl } from "../../services/asset";
import { mapCategoryToEn, mapCategoryToHr, mapModuleToHr } from "../../routes/LanguageMapper";
import { PageRoute, QueryParam } from "../../models";
import history from "../../history";

const showAllCategory = { module: "", name: "" };
const currentCategory = { module: "", name: "" };
function FilterSection(props: any) {
  const {
    module,
    selectedCategory,
    controls: groups,
    numberOfControls,
    onBackClick,
    isMobile,
    categories,
    normaliseSearchValues,
    modules,
    onModuleChange,
    resetFields,
    location: { search }
  } = props;

  const [category, setCategory] = useState(selectedCategory);
  const [submitData, setSubmitData] = useState(() => {
    const fromUrl = getUrlParams(search, QueryParam.searchQuery);
    if (fromUrl && Object.keys(fromUrl).length > 0) return fromUrl;
    return props.initialFilters || {};
  });

  const filteredGroups = filterGroupsByCondition(groups, submitData)
  // We have it from props
  //const categories = useSelector(selectCategories);

  useEffect(() => {
    const {
      selectedCategory,
      location: { search }
    } = props;
    //const selectedCategories = getSelectedCategories();

    //if (selectedCategories.length === 1) {
    //const { onCategoryChange } = props;
    //onCategoryChange(selectedCategories[0].name);
    //removed this line because of modules with one cat, for example: Tourism
    //}

    setCategory(selectedCategory);

    if (search) {
      setSubmitData(getUrlParams(search, QueryParam.searchQuery));
    }
  }, [
    JSON.stringify(categories) != JSON.stringify([]),
    JSON.stringify(groups) != JSON.stringify([]),
    selectedCategory,
    location.search,
    module,
  ]);

  const handleSubmit = () => {
    const hiddenFields = getHiddenFieldNames(groups, submitData);
    const filteredData = removeHiddenFields(submitData, hiddenFields);
    props.onSubmit({ ...normaliseSearchValues(filteredData), category }, true);
  };

  const handleReset = () => {
    setSubmitData({});
    setCategory(selectedCategory);
    resetFields();
    props.onSubmit({ category: selectedCategory }, false);
    scrollToTop();
    ReactGA.event({
      category: "Pretraga",
      action: "Click",
      label: "Resetiranje filtera - lista oglasa"
    });
  };


  const handleValuesChange = (values: any) => {
    let temp = { ...submitData };

    isObject(values) &&
      Object.keys(values).forEach(key => {
        temp = { ...temp, ...values[key] };
        if (isObject(values[key]) && Object.keys(values[key]).includes("categoryLv2Ids")) {
          delete temp.categoryLv1Ids;
        } else if (isObject(values[key]) && Object.keys(values[key]).includes("categoryLv1Ids")) {
          delete temp.categoryLv2Ids;
        }
      });

    setSubmitData(temp);
  };

  const handleCategoryChange = (value: any) => {
    const { onCategoryChange } = props;
    const isUserPage = history.location.pathname.includes(PageRoute.user);
    const recentSearchQuery = isUserPage ? {} : getRecentSearchQuery(value);
    setSubmitData({
      ...(!checkEmptyObject(recentSearchQuery) ? { category: value } : recentSearchQuery)
    });
    // @ts-ignore
    setCategory(value);
    onCategoryChange(
      mapCategoryToEn(value, module)
    );

    if (history.location.pathname.includes(PageRoute.search)) {
      history.replace(
        `/${mapModuleToHr(module)}/${mapCategoryToHr(value, module)}${PageRoute.search}${stringifyURI({
          ...(!checkEmptyObject(recentSearchQuery) ? { category: value } : recentSearchQuery)
        }, QueryParam.searchQuery, true)}`
      );
    } else {
      props.onSubmit({
        ...normaliseSearchValues({
          ...(!checkEmptyObject(recentSearchQuery) ? { category: value } : recentSearchQuery)
        })
      }, false);
    }
  }

  const handleModuleChange = (value: any) => {
    const { onModuleChange } = props;
    const isUserPage = history.location.pathname.includes(PageRoute.user);
    const recentSearchQuery = isUserPage ? {} : getRecentSearchQuery(value);
    setSubmitData({
      ...(!checkEmptyObject(recentSearchQuery) ? { module: value } : recentSearchQuery)
    });
    setCategory("");
    // @ts-ignore
    onModuleChange(value);

    if (history.location.pathname.includes(PageRoute.search)) {
      history.replace(
        `/${mapModuleToHr(module)}/${PageRoute.search}${stringifyURI({
          ...(!checkEmptyObject(recentSearchQuery) ? { category: value } : recentSearchQuery)
        }, QueryParam.searchQuery, true)}`
      );
    } else {
      props.onSubmit({
        ...normaliseSearchValues({
          ...(!checkEmptyObject(recentSearchQuery) ? { module: value } : recentSearchQuery)
        })
      }, false);
    }
  }


  const handleFilteredCategoryChange = ({ target: { value } }) => {
    const { module, category } = value;

    currentCategory.name = category;
    currentCategory.module = module;
    setSubmitData(prev => ({
      ...prev,
      category: mapCategoryToHr(category, module),
      module: mapModuleToHr(module)
    }));

    props.onSubmit({
      text: submitData.text,
      ...normaliseSearchValues({
        category: mapCategoryToHr(category, module),
        module: mapModuleToHr(module)
      })
    }, true);
  };

  const renderFilteredCategories = () => {
    const { filteredCategories } = props;
    const selectedCategories = getSelectedCategories();

    if (filteredCategories.length === 0) {
      return null;
    }

    if (!checkEmptyArray(selectedCategories)) {
      return (
        <Radio.Group
          defaultValue={showAllCategory}
          // @ts-ignore
          onChange={handleFilteredCategoryChange}
          className={styles.filteredGroup}
          value={currentCategory && currentCategory.name && currentCategory.module ? currentCategory : showAllCategory}
        >
          <div className={styles.filteredModule}>
            <span>{"Kategorija"}</span>
            <Radio value={showAllCategory}>
              {"Prikaži sve"}
            </Radio>
          </div>
          {filteredCategories.map((m: any, index: any) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={styles.filteredModule}>
              <span>{m.moduleName}</span>
              {m.categories.map((c: any) => {
                if (c.name === currentCategory.name) {
                  return (
                    <Radio key={`${c.name}_${c.module}`} value={currentCategory}>
                      <span className="filtered-categories">{c.displayName}</span>(
                      {formatNumber(c.count)})
                    </Radio>
                  )
                } else {
                  return (
                    <Radio key={`${c.name}_${c.module}`} value={{ category: c.name, module: c.module }}>
                      <span className="filtered-categories">{c.displayName}</span>(
                      {formatNumber(c.count)})
                    </Radio>
                  )
                }

              })}
            </div>
          ))}
        </Radio.Group>
      );
    }
  };

  const getSelectedCategories = () => {
    const { categories, module } = props;
    const selectedCategories = categories.filter(
      (category: any) => category.moduleRoute === mapModuleToHr(module)
    );

    return selectedCategories;
  };

  const renderCategorySelector = () => {
    const selectedCategories = getSelectedCategories();

    if (selectedCategories.length === 1) {
      //return null; 
      //removed this line because of modules with one cat, for example: Tourism
    }

    if (selectedCategories.length > 0) {

      const options = selectedCategories.map((c: any) => ({
        value: c.route,
        title: c.displayName
      }));

      //TODO: add reset option
      //if (category) {
      //  options.unshift({
      //    value: "",
      //    title: "Poništi",
      //    style: {
      //      borderBottom: "1px solid #e8e8e8"
      //    }
      //  });
      //}

      return (
        <div className={styles.category}>
          <span className="control-title">
            {"Potkategorija"}
          </span>
          <IndexSelect
            options={options}
            value={category}
            onChange={handleCategoryChange}
          />
        </div>
      );
    }
  }

  const renderModuleSelector = () => {
    if (!modules) {
      return null;
    }

    if (modules.length > 0) {

      const options = modules.map((c: any) => ({
        value: c.route,
        title: c.displayName
      }));

      if (module) {
        options.unshift({
          value: "",
          title: "Poništi",
          style: {
            borderBottom: "1px solid #e8e8e8"
          }
        });
      }

      return (
        <div className={styles.category}>
          <span className="control-title">
            {"Kategorija"}
          </span>
          <IndexSelect
            options={options}
            value={module}
            onChange={handleModuleChange}
          />
        </div>
      );
    }
  };

  const getPopupContainer = (trigger) => trigger.parentNode;

  var getActiveFilterPills = function () {
    if (!groups || !submitData) return [];
    var pills = [];
    var skipKeys = ["category", "module", "page", "sortOption", "text"];

    groups.forEach(function (group) {
      if (!group.controls) return;
      group.controls.forEach(function (control) {
        var hasValue = false;
        var pillId = control.id || control.field;

        // Skip controls whose field or id is in the skip list
        if (skipKeys.includes(control.field) || skipKeys.includes(control.id)) return;

        if (control.fromField && submitData[control.fromField]) hasValue = true;
        if (control.toField && submitData[control.toField]) hasValue = true;
        if (!hasValue && control.field && submitData[control.field]) hasValue = true;
        if (!hasValue && control.id && submitData[control.id]) hasValue = true;

        // multiFieldSelector - each option has its own field
        if (!hasValue && control.options && control.type === "MultiFieldSelector") {
          control.options.forEach(function (opt) {
            if (opt.field && submitData[opt.field]) {
              hasValue = true;
            }
          });
        }

        // multiLevel / inputLocation controls (make/model, location)
        if (!hasValue && control.child) {
          // Check if this is a categoryLv multiLevel control
          var categoryLvFields = ["categoryLv1Ids", "categoryLv2Ids"];
          var isCategoryLvControl = false;
          var ch = control.child;
          while (ch) {
            if (categoryLvFields.includes(ch.field)) { isCategoryLvControl = true; break; }
            ch = ch.child;
          }

          if (isCategoryLvControl) {
            // Collect all levels and check which have values
            var levels = [];
            var anyChildHasValue = false;
            var lvl = control;
            while (lvl) {
              var lf = lvl.field;
              var hasLvlValue = lf && !skipKeys.includes(lf) && submitData[lf] && (!Array.isArray(submitData[lf]) || submitData[lf].length > 0);
              levels.push({ field: lf, title: lvl.title, hasValue: hasLvlValue });
              if (hasLvlValue) anyChildHasValue = true;
              lvl = lvl.child;
            }
            // Show pills for levels that have values, and parent levels if any deeper level has a value
            var deeperHasValue = false;
            for (var i = levels.length - 1; i >= 0; i--) {
              if (levels[i].hasValue) deeperHasValue = true;
              if ((levels[i].hasValue || deeperHasValue) && levels[i].title && levels[i].field) {
                pills.push({ id: levels[i].field, title: levels[i].title });
              }
            }
          } else {
            var childField = control.child.field;
            if (childField && !skipKeys.includes(childField) && submitData[childField] && submitData[childField].length > 0) {
              hasValue = true;
            }
            // check nested children
            var child = control.child;
            while (child && child.child) {
              child = child.child;
              if (child.field && !skipKeys.includes(child.field) && submitData[child.field] && submitData[child.field].length > 0) {
                hasValue = true;
              }
            }
          }
        }

        if (hasValue && control.title) {
          pills.push({ id: pillId, title: control.title });
        }
      });
    });
    return pills;
  };

  var unorderedPills = getActiveFilterPills();
  var pillOrderRef = useRef([]);

  // Maintain insertion order: keep existing order, append new pills at the end
  var currentIds = unorderedPills.map(function (p) { return p.id; });
  var ordered = pillOrderRef.current.filter(function (id) { return currentIds.includes(id); });
  unorderedPills.forEach(function (p) {
    if (!ordered.includes(p.id)) {
      ordered.push(p.id);
    }
  });
  pillOrderRef.current = ordered;

  var activeFilterPills = ordered.map(function (id) {
    return unorderedPills.find(function (p) { return p.id === id; });
  });

  var tagsScrollRef = useRef(null);
  var tagsStickyRef = useRef(null);
  var [isTagsStuck, setIsTagsStuck] = useState(false);
  var [showLeftArrow, setShowLeftArrow] = useState(false);
  var [showRightArrow, setShowRightArrow] = useState(false);

  useEffect(function () {
    if (!isMobile || !tagsStickyRef.current) return;
    var observer = new IntersectionObserver(function (entries) {
      setIsTagsStuck(!entries[0].isIntersecting);
    }, { threshold: 1 });
    observer.observe(tagsStickyRef.current);
    return function () { observer.disconnect(); };
  }, [isMobile, activeFilterPills.length]);

  var updateTagArrows = function () {
    var el = tagsScrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  var prevMobilePillCountRef = useRef(0);

  var scrollMobileTagsToEnd = function () {
    var el = tagsScrollRef.current;
    if (el) {
      el.style.scrollBehavior = "auto";
      el.scrollLeft = el.scrollWidth;
      el.style.scrollBehavior = "";
      updateTagArrows();
    }
  };

  // Scroll to right on initial mount
  useEffect(function () {
    if (activeFilterPills.length > 0) {
      setTimeout(scrollMobileTagsToEnd, 100);
      setTimeout(scrollMobileTagsToEnd, 300);
      setTimeout(scrollMobileTagsToEnd, 600);
    }
  }, []);

  // Scroll to right when new pills are added
  useEffect(function () {
    var count = activeFilterPills.length;
    if (count > prevMobilePillCountRef.current && prevMobilePillCountRef.current > 0) {
      setTimeout(function () {
        var el = tagsScrollRef.current;
        if (el) {
          el.scrollTo({ left: el.scrollWidth, behavior: "smooth" });
        }
        updateTagArrows();
      }, 100);
    } else {
      updateTagArrows();
    }
    prevMobilePillCountRef.current = count;
  }, [activeFilterPills.length]);

  var scrollTags = function (dir) {
    var el = tagsScrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "left" ? -120 : 120, behavior: "smooth" });
  };

  var handlePillClick = function (fieldId, event) {
    // Scroll the clicked tag to the left in the horizontal tag list
    if (event && event.currentTarget && tagsScrollRef.current) {
      var tag = event.currentTarget;
      var container = tagsScrollRef.current;
      container.scrollTo({ left: tag.offsetLeft - container.offsetLeft, behavior: "smooth" });
    }

    var el = document.querySelector('[data-field-id="' + fieldId + '"]');
    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "center" });

    // Focus after scroll finishes
    var scrollTimer = null;
    var onScrollStop = function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        window.removeEventListener("scroll", onScrollStop);
        var isCheckbox = el.querySelector('[class*="checkboxField"]') || el.classList.contains('checkboxField');
        if (!isCheckbox) {
          var focusable = el.querySelector('input, select, [tabindex], .ant-select');
          if (focusable) {
            focusable.click();
          }
        }
      }, 150);
    };

    window.addEventListener("scroll", onScrollStop);
    setTimeout(onScrollStop, 150);
  };

  return (
    <div
      className={isMobile ? styles.sectionContainerMobile : null}
      style={{ height: "100%" }}
    >
      <div className={isMobile ? styles.containerMobile : styles.container}>
        <div className={isMobile ? styles.headerMobile : styles.header}>
          {`${"Filtriraj"}${numberOfControls !== null ? ` (${numberOfControls})` : ""}`}
          {!isMobile ? (
            <SearchSubmitButton onSubmit={handleSubmit} onReset={handleReset} />
          ) : (
            <React.Fragment>
              <Icon onClick={onBackClick} type="close" />
              <div className={styles.mobileFooter}>
                <span
                  className={styles.cancelBtn}
                  onClick={onBackClick}
                  role="presentation"
                >
                  {"Otkaži"}
                </span>
                <div className={styles.mobileFooterRight}>
                  <span
                    className={styles.resetBtn}
                    onClick={handleReset}
                    role="presentation"
                  >
                    <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
                  </span>
                  <span
                    className={styles.okButton}
                    onClick={handleSubmit}
                    role="presentation"
                  >
                    {"Traži"}
                  </span>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        {isMobile && activeFilterPills.length > 0 && (
          <React.Fragment>
          <div ref={tagsStickyRef} style={{ height: 1 }} />
          <div className={styles.activeFilterLabel}>Odabrani filtri:</div>
          <div className={`${styles.activeFilterTagsWrapper} ${isTagsStuck ? styles.activeFilterTagsStuck : ""}`}>
            {showLeftArrow && (
              <span className={styles.tagArrow} onClick={function () { scrollTags("left"); }}>
                <Icon type="left" />
              </span>
            )}
            <div className={styles.activeFilterTags} ref={tagsScrollRef} onScroll={updateTagArrows}>
              {activeFilterPills.map(function (pill) {
                return (
                  <Tag
                    key={pill.id}
                    className={styles.activeFilterTag}
                    onClick={function (e) { handlePillClick(pill.id, e); }}
                  >
                    <span>{pill.title}</span>
                  </Tag>
                );
              })}
            </div>
            {showRightArrow && (
              <span className={styles.tagArrow} onClick={function () { scrollTags("right"); }}>
                <Icon type="right" />
              </span>
            )}
          </div>
          </React.Fragment>
        )}
        {renderModuleSelector()}
        {renderCategorySelector()}
        {renderFilteredCategories()}
        <SearchControls
          // @ts-ignore
          key={location.search} // Force re-render when URL changes
          onSubmit={handleSubmit}
          onReset={handleReset}
          groups={filteredGroups}
          onValuesChange={handleValuesChange}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          showAllSearch={
            !checkEmptyArray(getSelectedCategories()) ? false : true
          }
          getPopupContainer={getPopupContainer}
          openAllSearchRef={props.openAllSearchRef}
          activeFilterPills={activeFilterPills}
        />
      </div>
      {props.children}
    </div>
  );
}

FilterSection.defaultProps = {
  isMobile: false,
  adCreator: {},
  controls: [],
  selectedCategory: "",
  numberOfControls: null,
  location: {},
  onBackClick: () => null,
  onModuleChange: () => null,
};

export default handleSearchControl(FilterSection, getAdvancedSearchConfig);



// WEBPACK FOOTER //
// ./src/containers/SearchPage/FilterSection.tsx